import React from 'react';
import { Themes } from './theme.models';
import settings from './theme.settings';
// Create context which holds the theme state
export const ThemeContext = React.createContext({
    settings: settings[Themes.ZIGGO_WS2],
    setCurrentTheme: (_1) => {
        //
    },
});
//# sourceMappingURL=theme.context.js.map